(function() {
  if (window.__nnInsulatedBoxInit) return;
  window.__nnInsulatedBoxInit = true;
  var NN_BOX_HANDLE = 'insulated-48-hour-shipping-box-ice-packs';
  var NN_DISMISS_KEY = 'nnHeatUpsellDismissed';

  // Per-visit opt-out. sessionStorage (not localStorage) on purpose: the box is
  // protective, so we honor the dismissal for the rest of this visit but re-offer
  // it on a future visit rather than suppressing it forever.
  function nnUpsellDismissed() {
    try { return sessionStorage.getItem(NN_DISMISS_KEY) === '1'; } catch (e) { return false; }
  }
  function nnClearDismissed() {
    try { sessionStorage.removeItem(NN_DISMISS_KEY); } catch (e) {}
  }
  function nnHideUpsellWidgets() {
    document.querySelectorAll('#nn-heat-upsell').forEach(function(w) { w.style.display = 'none'; });
  }

  // The opt-out is scoped to the current set of heat-sensitive items. The server
  // stamps the live heat-sensitive count into #nn-hs-state on every drawer render
  // (/cart.js can't see product tags). When the cart drops to zero heat-sensitive
  // items, the decision context is gone — clear the opt-out so the next
  // heat-sensitive item re-shows the notice. Returns the count, or -1 if unknown.
  function nnHeatSensitiveCount() {
    var marker = document.getElementById('nn-hs-state');
    if (!marker) return -1;
    var n = parseInt(marker.getAttribute('data-hs-count'), 10);
    return isNaN(n) ? -1 : n;
  }
  function nnMaybeResetDismissal() {
    if (nnHeatSensitiveCount() === 0) nnClearDismissed();
  }

  window.nnDismissInsulatedBox = function(btn) {
    if (btn) btn.disabled = true;
    try { sessionStorage.setItem(NN_DISMISS_KEY, '1'); } catch (e) {}
    nnHideUpsellWidgets();
  };

  window.nnAddInsulatedBox = function(btn) {
    if (!btn || btn.disabled) return;

    var variantId  = parseInt(btn.getAttribute('data-variant-id'), 10);
    var labelEl    = btn.querySelector('.nn-heat-upsell__btn-label');
    var spinnerEl  = btn.querySelector('.nn-heat-upsell__btn-spinner');
    var doneEl     = btn.querySelector('.nn-heat-upsell__btn-done');

    if (!variantId) return;

    btn.disabled = true;
    if (labelEl)   labelEl.hidden   = true;
    if (spinnerEl) spinnerEl.hidden = false;

    var cartHelper = (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) || null;
    var sectionIds = cartHelper && typeof cartHelper.getSectionsToRender === 'function'
      ? cartHelper.getSectionsToRender().map(function(s) { return s.id; })
      : ['cart-drawer'];

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds
      })
    })
    .then(function(r) {
      if (!r.ok) return r.text().then(function(t) { throw new Error('cart/add failed ' + r.status + ': ' + t); });
      return r.json();
    })
    .then(function(response) {
      if (spinnerEl) spinnerEl.hidden = true;
      if (doneEl)    doneEl.hidden    = false;
      btn.classList.add('nn-heat-upsell__btn--success');

      if (cartHelper && typeof cartHelper.reRenderSections === 'function' && response.sections) {
        try { cartHelper.reRenderSections(response.sections); } catch (e) {}
        setTimeout(window.nnSyncWidgetVisibility, 100);
      } else {
        setTimeout(window.nnRefreshCartDrawer, 200);
      }
    })
    .catch(function(err) {
      console.error('[NN] Insulated box add failed:', err);
      btn.disabled = false;
      if (spinnerEl) spinnerEl.hidden = true;
      if (labelEl)   labelEl.hidden   = false;
    });
  };

  // Fallback refresh — only used if Eurus's reRenderSections isn't available
  window.nnRefreshCartDrawer = function() {
    fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var html = sections['cart-drawer'];
        if (!html) return;

        var parser = new DOMParser();
        var newDoc = parser.parseFromString(html, 'text/html');
        var newEl = newDoc.querySelector('#CartDrawer');
        var curEl = document.querySelector('#CartDrawer');

        if (newEl && curEl) {
          // NN fix (V3c): innerHTML swap only. Alpine 3.10.5's mutation observer
          // auto-initializes injected content, so a manual Alpine.initTree(curEl)
          // here was a double-init landmine (re-bound x-data, duplicate handlers).
          curEl.innerHTML = newEl.innerHTML;
          window.nnSyncWidgetVisibility();
        }
      })
      .catch(function() {});
  };

  // Fallback: hide widget client-side if box is in cart but server-rendered widget is still showing.
  window.nnSyncWidgetVisibility = function() {
    // Reset the opt-out if the cart no longer has any heat-sensitive items.
    // Marker path: covers a NON-empty cart whose heat-sensitive items were all removed.
    nnMaybeResetDismissal();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Empty-cart path: when the cart drops to zero items the drawer renders its
        // empty state (cart-drawer.liquid: {%- if cart == empty -%}), so #nn-hs-state
        // is NOT in the DOM and the marker path above can't observe the drop to zero.
        // /cart.js is authoritative here — an empty cart has no heat-sensitive items,
        // so the decision context is gone: clear the opt-out so the next
        // heat-sensitive item re-shows the notice.
        if (!cart.items || cart.items.length === 0) {
          nnClearDismissed();
        }
        var hasBox = (cart.items || []).some(function(item) {
          return item.handle === NN_BOX_HANDLE;
        });
        var hide = hasBox || nnUpsellDismissed();
        document.querySelectorAll('#nn-heat-upsell').forEach(function(w) {
          w.style.display = hide ? 'none' : '';
        });
      })
      .catch(function() {});
  };

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.nnSyncWidgetVisibility);
  } else {
    window.nnSyncWidgetVisibility();
  }

  // Patch fetch so we re-sync after any /cart/* mutation done by Eurus or anything else.
  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0] || '';
    var isCartMutation = typeof url === 'string' &&
      (url.indexOf('/cart/add') !== -1 ||
       url.indexOf('/cart/change') !== -1 ||
       url.indexOf('/cart/update') !== -1 ||
       url.indexOf('/cart/clear') !== -1);
    var result = originalFetch.apply(this, args);
    if (isCartMutation) {
      result.then(function() { setTimeout(window.nnSyncWidgetVisibility, 200); }).catch(function() {});
    }
    return result;
  };

  // Also observe DOM for widget re-appearance (defensive — drawer is AJAX-injected on every open)
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function() {
      if (document.getElementById('nn-heat-upsell')) {
        // Dismissed? hide the freshly-injected widget immediately (no flash),
        // then reconcile against the live cart.
        if (nnUpsellDismissed()) nnHideUpsellWidgets();
        window.nnSyncWidgetVisibility();
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // NN V9 note-saved bridge. Lives here (an always-executed asset) because the cart
  // drawer markup is innerHTML-injected — <script> tags inside it never run. State
  // goes on the GLOBAL xCartHelper Alpine store (reactive across every drawer clone;
  // the drawer is template-cloned per breakpoint container, so per-element events
  // miss the visible clone). All writes are plain JS — no Alpine scope traps.
  if (!window.__nnNoteBridge) {
    window.__nnNoteBridge = true;
    var nnNoteTimer = null;
    document.addEventListener('eurus:cart-drawer:order-note:update', function (e) {
      // keep every clone's textarea in sync with the saved note
      var msg = (e && e.detail && typeof e.detail.message === 'string') ? e.detail.message : '';
      document.querySelectorAll('#x-cart-note, textarea[id^="x-cart-note"]').forEach(function (ta) { ta.value = msg; });
      if (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) {
        Alpine.store('xCartHelper').nnNoteSaved = true;
        clearTimeout(nnNoteTimer);
        nnNoteTimer = setTimeout(function () { Alpine.store('xCartHelper').nnNoteSaved = false; }, 3500);
      }
    });
  }
})();
